import React from 'react';
import ProductItemView from '../ProductItemView';
import mid247 from '../../resource/middleware/247.svg';

const Allday = () => {
    return (
        <ProductItemView
            title="Funcionamiento 24/7 sin intervención humana"
            items={["Mecanismos de chequeo y reconexión automática", "Mas de 450 escenarios testeados automaticamente"]}
            image={mid247}
            centered />
    );
};

export default Allday;